// extracted by mini-css-extract-plugin
export var comments = "recipe-module--comments--c02bf";
export var content = "recipe-module--content--a6524";
export var editLoading = "recipe-module--edit-loading--542ea";
export var error = "recipe-module--error--1d1e2";
export var hero = "recipe-module--hero--1d9b1";
export var heroContent = "recipe-module--hero-content--bb6fc";
export var heroRatioClass = "recipe-module--hero-ratio-class--0b3c4";
export var layout = "recipe-module--layout--cdf4e";
export var loader = "recipe-module--loader--301b1";
export var rating = "recipe-module--rating--9e8c8";
export var ratingContainer = "recipe-module--rating-container--89097";
export var related = "recipe-module--related--1f2bf";
export var relatedSeparator = "recipe-module--related-separator--c7f47";